import { t } from '@lingui/macro'
import { IResourceCsvResponse } from './DownloadResourcesCSV'

export const prepareCSVResourcesExport = (data) => {
  return data.map((row: IResourceCsvResponse) => {
    const { topic } = row
    return {
      [t`Views`]: row.viewsCount,
      [t`Resource name`]: topic.currentTitle,
      [t`Pass rate`]: `${row.passRate}%`,
      [t`Last viewed at`]: topic.lastViewedAt,
      [t`Is Archived`]: !!topic.deleted_at,
      [t`Workspace name`]: topic.workspace.name,
      [t`Workspace ID`]: topic.workspace.id,
      [t`Author email`]: topic.author.email,
      [t`Author first name`]: topic.author.first_name,
      [t`Author last name`]: topic.author.last_name,
      [t`Author position`]: topic.author.position,
      [t`Author area`]: topic.author.area,
      [t`Author location`]: topic.author.location,
      [t`Author department`]: topic.author.department,
      [t`Author custom 1`]: topic.author.custom_1,
      [t`Author custom 2`]: topic.author.custom_2,
      [t`Author custom 3`]: topic.author.custom_3,
      [t`Author account name`]: topic.author.account_name,
      [t`Average Rating`]: topic.averageRating > 0 ? topic.averageRating : '',
      [t`Rating count`]: topic.number_rated
    }
  })
}
